import { client } from "@client";
import { useEntryIntakeStore } from "@entry";
import { resetModalQueue } from "@hooks/application/useModalQueue";
import { Intercom } from "@services";
import { clearSessionFromStorage } from "@utils";

export const useLogout = () => {
  const logout = () => {
    clearSessionFromStorage();
    useEntryIntakeStore.getState().clearIntake();
    Intercom.shutdown();
    client.clearStore();
    resetModalQueue();
  };

  return { logout };
};
